// extracted by mini-css-extract-plugin
module.exports = {"bookshelfItem":"UserBookshelvesList__bookshelfItem"};